<!-- Add-Edit Booking Modal -->
<div class="modal-body pt-3">
    <div class="register-form">
        <form [formGroup]="form">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="formSection">
                        <div class="head">
                            <strong>Booking Information</strong>
                        </div>
                    </div>
                    <div class="form-background">
                        <input type="text" formControlName="id" hidden />
                        <div class="row" style="padding: 10px;">
                            <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>Project <span class="formMandatoryInput">*</span></label>
                                    <input type="text" id="pname" formControlName="project" class="form-control project"
                                        readonly />
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>Agent Name<span class="formMandatoryInput"> *</span></label>
                                    <ng-select formControlName="sourceName"
                                        [ngClass]="{'is-invalid': Submitted && f['sourceName'].errors}">
                                        <ng-option value="">Select Agent Name</ng-option>
                                        <ng-option *ngFor="let agent of bookingRelatedData?.agentList"
                                            [value]="agent.id">{{agent.fullName}}</ng-option>
                                    </ng-select>
                                    <div *ngIf="Submitted && f['sourceName'].errors"
                                        style="color: red; font-size: 12px;">Agent name is reqiured.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-xs-4 col-sm-4 col-md-2 col-lg-2">
                                <div class="form-group initials">
                                    <label>Initial <span class="formMandatoryInput">*</span></label>
                                    <ng-select formControlName="nameInitialsId" class="initials"
                                        [readonly]="currentBooking"
                                        [ngClass]="{'is-invalid': Submitted && f['nameInitialsId'].errors}">
                                        <ng-option value="-1">Select Initial</ng-option>
                                        <ng-option *ngFor="let initial of bookingRelatedData?.nameInitialsList"
                                            [value]="initial.id">{{ initial.name}}</ng-option>
                                    </ng-select>
                                    <div *ngIf="Submitted && f['nameInitialsId'].errors"
                                        style="color: red; font-size: 12px;">Name initial is reqiured.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-xs-8 col-sm-8 col-md-4 col-lg-4">
                                <div class="form-group">
                                    <label>Client Name <span class="formMandatoryInput">*</span></label>
                                    <span style="float: right; cursor: pointer;" *ngIf="!currentBooking"
                                        (click)="toggleCustomerList()"><img src="{{ customerIcon }}"
                                            class="userIcon" /></span>
                                    <input type="text" formControlName="clientName" placeholder="Enter Client Name"
                                        class="form-control customer" [readonly]="currentBooking"
                                        [ngClass]="{'is-invalid': Submitted && f['clientName'].errors}"
                                        [attr-disabled]="!currentBooking" />
                                    <div *ngIf="Submitted && f['clientName'].errors"
                                        style="color: red; font-size: 12px;">Client name is reqiured.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>Phone No <span class="formMandatoryInput"> *</span></label>
                                    <input formControlName="contactNumber" class="form-control noscroll phoneno"
                                        (keypress)="_keyPress($event)" type="text" maxlength="10"
                                        [readonly]="currentBooking" placeholder="Enter Phone Number"
                                        [ngClass]="{'is-invalid': Submitted && f['contactNumber'].errors}" />
                                    <div *ngIf="Submitted && f['contactNumber'].hasError('required')"
                                        style="color: red; font-size: 12px;">Contact number is reqiured.
                                    </div>
                                    <div *ngIf="Submitted && (f['contactNumber'].hasError('minlength') || f['contactNumber'].hasError('maxlength'))"
                                        style="color: red; font-size: 12px;">Contact number should be 10
                                        digit.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>Pan Card Number<span class="formMandatoryInput"> *</span></label>
                                    <input formControlName="panCardNum" class="form-control panCard"
                                        placeholder="Enter Pan Card Number" [readonly]="currentBooking" maxlength="10"
                                        [ngClass]="{'is-invalid': Submitted && f['panCardNum'].errors}">
                                    <div *ngIf="Submitted && f['panCardNum'].errors?.['required']"
                                        style="color: red; font-size: 12px;">Pan card number is reqiured.
                                    </div>
                                    <div *ngIf="f['panCardNum'].errors?.['pattern']"
                                        style="color: red; font-size: 12px;">Invalid PAN number format.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>Unit Category<span class="formMandatoryInput"> *</span></label>
                                    <ng-select formControlName="product" (change)="changeUnitCategory($event);"
                                        [ngClass]="{'is-invalid': Submitted && f['product'].errors}">
                                        <ng-option value="">Select Unit Category</ng-option>
                                        <ng-option *ngFor="let unit of bookingRelatedData?.unitcategoryList"
                                            [value]="unit">{{unit.name}}</ng-option>
                                    </ng-select>
                                    <div *ngIf="Submitted && f['product'].errors" style="color: red; font-size: 12px;">
                                        Unit category is reqiured.</div>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label for="buttondisplay">Date of Booking</label>
                                    <div class="d-flex align-items-center">
                                        <p-calendar [(ngModel)]="bookingDate" formControlName="bookingDate"
                                            dateFormat="dd/mm/yy" [maxDate]="maxDate"
                                            [ngClass]="{'is-invalid': Submitted && f['bookingDate'].errors}"
                                            [showIcon]="true" inputId="buttondisplay" [showOnFocus]="false"
                                            class="custom-calendar" />
                                        <div *ngIf="Submitted && f['bookingDate'].errors"
                                            style="color: red; font-size: 12px;">Date of booking is reqiured.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>Rate Offered <span class="formMandatoryInput">*</span></label>
                                    <input type="number" formControlName="rateOffered" class="form-control"
                                        placeholder="Enter Rate Offered"
                                        [ngClass]="{'is-invalid': Submitted && f['rateOffered'].errors}"
                                        (input)="calculateAmount()">
                                    <div *ngIf="Submitted && f['rateOffered'].errors"
                                        style="color: red; font-size: 12px;">Rate offered is reqiured.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <strong>Super Area</strong><br />
                                    <span>{{superArea}} {{unitMeasurement}}</span>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <strong>Built Area</strong><br />
                                    <span>{{builtupArea}} {{unitMeasurement}}</span>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <strong>Carpet Area</strong><br />
                                    <span>{{carpetarea}} {{unitMeasurement}}</span>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>Amount <span class="formMandatoryInput">*</span></label>
                                    <input type="text" formControlName="amount" class="form-control amount"
                                        [ngClass]="{'is-invalid': Submitted && f['amount'].errors}" readonly />
                                    <div *ngIf="Submitted && f['amount'].errors" style="color: red; font-size: 12px;">
                                        Amount is reqiured.</div>
                                </div>
                            </div>

                            <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>Previous Booking</label>
                                    <span style="float: right; cursor: pointer;" *ngIf="!currentBooking"
                                        (click)="toggleCancelledBookingList()"><img src="{{ customerIcon }}"
                                            class="userIcon" /></span>
                                    <input type="text" formControlName="cancelledBookingClientName"
                                        placeholder="Select Previous Cancelled Booking" class="form-control customer"
                                        [readonly]="true" />
                                </div>
                            </div>

                            <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>Payment Plan <span class="formMandatoryInput">*</span></label>
                                    <ng-select formControlName="paymentPlansId"
                                        [ngClass]="{'is-invalid': Submitted && f['paymentPlansId'].errors}">
                                        <ng-option value="">Select Payment Plan</ng-option>
                                        <ng-option *ngFor="let plan of bookingRelatedData?.paymentPlansList"
                                            [value]="plan.id">{{plan.name}}</ng-option>
                                    </ng-select>
                                    <div *ngIf="Submitted && f['paymentPlansId'].errors"
                                        style="color: red; font-size: 12px;">Payment plan is reqiured.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div class="form-group">
                                    <label>Remarks</label>
                                    <textarea type="text" formControlName="remark" placeholder="Enter Remarks"
                                        class="form-control"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pad-wrap col-sm-12">
                <div class="form-operation-buttons">
                    <button type="submit" class="btn btn-primary mr-2" [disabled]="isSubmitDisabled"
                        (click)="onSubmit()">Submit</button>
                    <button type="button" class="btn btn-secondary" (click)="changeModalState(false)">Cancel</button>
                </div>
            </div>
        </form>
    </div>
</div>

<p-dialog [(visible)]="showOverlay" [modal]="true" [draggable]="false" [resizable]="false" *ngIf="showOverlay"
    [style]="{ height: '30rem' }">
    <p-header>
        <h3>Client List</h3>
    </p-header>
    <div>
        <app-common-list (setValues)="setSelecetdCustomer($event)" [columns]="columns" [rowSelection]="'single'"
            [suppressContextMenu]="true" [gridData]="customerListWithClientName"
            (hideModal)="toggleCustomerList()"></app-common-list>
    </div>
</p-dialog>

<!-- Cancelled bookings list against which any fresh booking not done yet -->
<p-dialog [(visible)]="showCancelledBookings" [modal]="true" [draggable]="false" [resizable]="false"
    [style]="{ height: '30rem' }">
    <p-header>
        <h3>Cancelled Booking List</h3>
    </p-header>
    <div>
        <app-common-list (setValues)="setSelectedCancelledBooking($event)" [columns]="CancelledBookingColumns"
            [rowSelection]="'single'" [suppressContextMenu]="true" [gridData]="cancelledBookingList"
            (hideModal)="toggleCancelledBookingList()"></app-common-list>
    </div>
</p-dialog>